import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/library", label: "漫画大全" },
  { to: "/booklists", label: "书单" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/library?keyword=${encodeURIComponent(keyword.trim())}`);
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="妖精漫画网首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-sparkling-2-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-display text-2xl leading-none text-foreground-950">妖精漫画网</span>
        </Link>

        <ul className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `block whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <form onSubmit={handleSearch} className="hidden flex-1 justify-end lg:flex" role="search">
          <label className="flex w-full max-w-xs items-center gap-2 rounded-full border border-background-300/70 bg-background-100 px-4 py-2">
            <i className="ri-search-line text-sm text-foreground-500" aria-hidden="true"></i>
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜漫画、作者或标签"
              aria-label="搜索漫画"
              className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
          </label>
        </form>

        <div className="flex items-center gap-2 md:hidden">
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-900"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <form onSubmit={handleSearch} className="mb-3 flex items-center gap-2 rounded-full border border-background-300/70 bg-background-100 px-4 py-2" role="search">
            <i className="ri-search-line text-sm text-foreground-500" aria-hidden="true"></i>
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜漫画、作者或标签"
              aria-label="搜索漫画"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </form>
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `block rounded-xl px-4 py-3 text-sm font-medium ${isActive ? "bg-primary-100 text-primary-700" : "text-foreground-700 hover:bg-background-100"}`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}